import { useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { getUrl, getMlUrl, ifItems } from "./general.js"

async function processMl(user, sound_key, lat, lon, week, token) {
    let url = getMlUrl(`/ml/tasks/api`,)
    let data = {
        "ml_config": {
            "species": {
                "lat": lat,
                "lon": lon,
                "week": week,
                "density_threshold": 0.01
            },
            "audio": {
                "chunking": {
                    "overlap": 0,
                    "duration": 3
                }
            },
            "sigmoid_sensitivity": 1,
            "threshold": 0.75
        },
        "api": {
            "user": user,
            "key": sound_key
        }
    }
    console.log("posting ml job...", data, url)
    return await fetch(url, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(data),
    })
        .then(res => res.json())
        .then(ifItems)
        .catch(err => { console.log(err) })
}


function startMl() {
    let url = getUrl(`/_rpc/ml/on`)
    console.log(`fetching ${url}...`)
    return fetch(url, { method: "POST" })
        .then(res => res.json())
        .then(ifItems)
        .catch(err => { console.log(err) })
}


function getMlState() {
    let url = getUrl(`/_rpc/ml/state`)
    console.log(`fetching ${url}...`)
    return fetch(url)
        .then(res => res.json())
        .then(ifItems)
        .catch(err => { console.log(err) })
}


function getSoundUrlRead(user, object_key) {
    var url
    url = getUrl(`/sounds/${user}/${object_key}/url/read`)
    console.log(`fetching ${url}...`)
    return fetch(url, { method: 'POST' })
        .then(res => res.json())
        .then(ifItems)
        .catch(err => { console.log(err) })
}


function getDetections(user, object_key) {
    var url
    url = getUrl(`/detections/${user}/${object_key}`)
    console.log(`fetching ${url}...`)
    return fetch(url)
        .then(res => res.json())
        .then(ifItems)
        .catch(err => { console.log(err) })
}


function getSound(user, object_key) {
    var url
    url = getUrl(`/sounds/${user}/${object_key}`)
    console.log(`fetching ${url}...`)
    return fetch(url)
        .then(res => res.json())
        .then(ifItems)
        .catch(err => { console.log(err) })
}

function getSounds(user, page, limit, sorts, filters, headers = {}) {
    var skip = (page - 1) * limit
    // console.log(limit, page, skip)
    var url
    var query = { user: user, limit: limit, skip: skip }
    if (filters) {
        query = { ...query, ...filters }
    }
    url = getUrl(`/sounds/`, query)
    console.log(`fetching ${url}...`)
    return fetch(url, { headers: headers })
        .then(res => res.json())
        .then(ifItems)
        .catch(err => { console.log(err) })
}


function deleteSound(user, object_key) {
    let url = getUrl(`/sounds/${user}/${object_key}`, {})
    console.log(`deleting ${url}`)
    return fetch(url, { method: 'DELETE' })
        .then(res => res.json())
        .catch(err => { console.log(err) })
}


function getFiles(user, page, limit) {
    let skip = page * limit
    // console.log(limit, page, skip)
    let url = getUrl(`/recordings/`, { user: user, limit: limit, skip: skip })
    console.log(`fetching ${url}...`)
    return fetch(url, { mode: 'cors', credentials: 'include' })
        .then(res => res.json())
        .then(ifItems)
        .catch(err => { console.log(err) })
}

function getEtags(etag) {
    var url
    url = getUrl(`/sounds/etag/${etag}`)
    console.log(`fetching ${url}...`)
    return fetch(url)
        .then(res => res.json())
        .catch(err => { console.log(err) })
}

async function getSpecieList(lim, token) {
    const url = getMlUrl('/ml/labels', { limit: lim })
    try {
        const response = await fetch(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        // Convert the JSON response to JS
        return await response.json()
    } catch (error) {
        console.error(error)
    }
}

const editSound = async (soundId, requestingUser, token, updatedData) => {
    try {
        const url = getUrl(`/sounds/${requestingUser}/${soundId}`)
        console.log(url)
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedData),
        })
        const data = await response.json()
        return data
    }
    catch (error) {
        console.error(error)
    }
}

export {
    startMl,
    processMl,
    getMlState,
    getFiles,
    getSounds,
    getSound,
    deleteSound,
    getSoundUrlRead,
    getDetections,
    getEtags,
    getSpecieList,
    editSound,
}
